// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"87a3921d","453":"16ac990a"}[chunkId] + ".chunk.js";
};